// Lobby filters: first the three categories, then the games that actually exist inside the chosen one.
export const FORMAT_FILTERS = [
  { key: "CASH", label: "Cash" },
  { key: "SNG", label: "Sit N Go" },
  { key: "MTT", label: "MTT" },
];

export const GAME_LABELS = {
  HOLDEM: "Hold 'Em",
  PLO4: "PLO",
  PLO5: "PLO5",
  PLO6: "PLO6",
  PINEAPPLE: "Pineapple",
  CRAZY_PINEAPPLE: "Crazy Pineapple",
  OMAHA_HILO: "Omaha Hi/Lo",
  FIVE_CARD_DRAW: "5-Card Draw",
  FIVE_CARD_TRIPLE_DRAW: "5-Card Triple Draw",
  TRIPLE_DRAW_27: "2-7 Triple Draw",
  SINGLE_DRAW_27: "2-7 Single Draw",
  STUD: "Stud",
  RAZZ: "Razz",
  STUD_HILO: "Stud Hi/Lo",
};

const ORDER = Object.keys(GAME_LABELS);
export const sortGames = (keys) => [...new Set(keys)].sort((a, b) => ORDER.indexOf(a) - ORDER.indexOf(b));

const chip = (on) => `rounded-full px-5 py-1.5 text-xs font-display uppercase tracking-[0.15em] btn-lift ${on ? "btn-gold" : "border border-amber-200/25 text-amber-100/80 hover:border-amber-300/60"}`;

export const FormatFilters = ({ value, onChange }) => (
  <div className="flex gap-2 flex-wrap" data-testid="format-filters">
    {FORMAT_FILTERS.map((f) => (
      <button key={f.key} data-testid={`format-filter-${f.key}`} onClick={() => onChange(f.key)} aria-pressed={value === f.key} className={chip(value === f.key)}>
        {f.label}
      </button>
    ))}
  </div>
);

export const GameFilters = ({ value, games, onChange }) => (
  <div className="flex gap-2 flex-wrap" data-testid="game-filters">
    <button data-testid="game-filter-ALL" onClick={() => onChange("ALL")} aria-pressed={value === "ALL"} className={chip(value === "ALL")}>All</button>
    {sortGames(games || []).map((g) => (
      <button key={g} data-testid={`game-filter-${g}`} onClick={() => onChange(g)} aria-pressed={value === g} className={chip(value === g)}>
        {GAME_LABELS[g] || g}
      </button>
    ))}
  </div>
);
